import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularSplitModule} from 'angular-split';

import {CaseFormsComponent} from './case-forms.component';
import {CaseViewComponent} from './case-view/case-view.component';
import {CaseFormViewComponent} from './case-form-view/case-form-view.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import {DxListModule, DxPopoverModule, DxTreeListModule } from 'devextreme-angular';

import {FormsFormModule} from '../forms/forms-form/forms-form.module';
import {MatIconModule} from '@angular/material/icon';

import {CaseAddProcedureComponent} from './case-add-procedure/case-add-procedure.component';

import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {FormsTDOModule} from '../forms/froms.module';
import {CaseItemFormRemoveCancelComponent} from './case-item-form-remove-cancel/case-item-form-remove-cancel.component';
import {CaseProcedureAddFormComponent} from './case-procedure-add-form/case-procedure-add-form.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {TreatmentModule} from '../treatment/treatment.module';
import {FinalReportModule} from '../forms/custom/final-report/final-report.module';
import {CaseItemSelectComponent} from './case-item-select/case-item-select.component';
import {MtiModule} from '../forms/custom/mti/mti.module';
import {TreatmentPlanningModule} from '../treatment-planning/treatment-planning.module';
import { CheckOutComponent } from './check-out/check-out.component';
import { CheckOutAdaClaimDialogComponent } from './check-out/check-out-ada-claim-dialog/check-out-ada-claim-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {PerioModule} from "../perio/perio.module";
import { CaseViewWorkItemEventsDialogComponent } from './case-view/dialog/case-view-work-item-events-dialog/case-view-work-item-events-dialog.component';
import { CaseViewPatientFormsDetailsDialogComponent } from './case-view/dialog/case-view-patient-forms-details-dialog/case-view-patient-forms-details-dialog.component';
import { CaseBillFunctionalityComponent } from './case-bill-functionality/case-bill-functionality.component';
import { CaseFinalReportSelectComponent } from './case-final-report-select/case-final-report-select.component';
import { SurgicalDiagnosisModule } from 'src/app/models/forms/Surgical/surgical-diagnosis/surgical-diagnosis.module';
import { SurgicalTreatmentModule } from 'src/app/models/forms/Surgical/surgical-treatment/surgical-treatment.module';

@NgModule({
    declarations: [
        CaseFormsComponent,
        CaseViewComponent,
        CaseFormViewComponent,
        CaseAddProcedureComponent,
        CaseItemFormRemoveCancelComponent,
        CaseProcedureAddFormComponent,
        CaseItemSelectComponent,
        CheckOutComponent,
        CheckOutAdaClaimDialogComponent,
        CaseViewWorkItemEventsDialogComponent,
        CaseViewPatientFormsDetailsDialogComponent,
        CaseBillFunctionalityComponent,
        CaseFinalReportSelectComponent
    ],
    imports: [
        CommonModule,
        AngularSplitModule,
        FormsModule,
        FormsFormModule,
        DxListModule,
        DxTreeListModule,
        DxPopoverModule,
        MatCardModule,
        MatTooltipModule,
        MatDividerModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSnackBarModule,
        MatIconModule,
        FormsTDOModule,
        MatTabsModule,
        TdoControlsModule,
        TreatmentModule,
        FinalReportModule,
        SurgicalDiagnosisModule,
        SurgicalTreatmentModule,
        MtiModule,
        TreatmentPlanningModule,
        ReactiveFormsModule,
        MatRadioModule,
        PerioModule
    ],
    exports: [
        CaseFormsComponent,
        CaseViewComponent,
        CaseFormViewComponent,
        CheckOutComponent
    ]
})
export class CaseFormsModule {
}
